import { render, staticRenderFns } from "./bottomMenuItem.vue?vue&type=template&id=7260d2fc&"
import script from "./bottomMenuItem.vue?vue&type=script&lang=js&"
export * from "./bottomMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports